module.exports = __webpack_public_path__ + "static/img/image_2697049_spike.27b9aea1.svg";